import { Directive } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[trimInput]'
})
export class TrimInputDirective {

  constructor(private ngControl: NgControl) {
    this.trimValueAccessor(this.ngControl.valueAccessor);
  }

  trimValueAccessor(valueAccessor: ControlValueAccessor) {
    const original = valueAccessor.registerOnChange;

    valueAccessor.registerOnChange = (fn: (_: unknown) => void) => {
      return original.call(valueAccessor, (value: unknown) => {
        return fn(typeof value === 'string' ? value.trim() : value);
      });
    };
  }

}
